import _BaseView from "./_BaseView";
import Confirm from "../components/Confirm";
import Api from "../Api";

export default class DupesView extends _BaseView
{
    init() {
        super.init();
        $('.btn.merge-dupes').on('click', function () {
            const $table = $(this).parents('.mergeDupes');
            const firstname = $(this).data('firstname');
            const lastname = $(this).data('lastname');
            const id = $(this).data('id');
            Confirm({
                ok: 'Merge',
                title: `${firstname} ${lastname}`,
                msg: `<strong>Merge ${firstname} ${lastname}</strong><br>
                    Are you sure?<br><br><strong class="msg-box danger">This cannot be undone.</strong>`,
                onConfirm: function () {
                    Api.send(`/api/users/merge`, {id: id}, 'post').done(function () {
                        $table.remove();
                    });
                }
            });
            return false;
        });
    }
}